import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { productShortName, systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-gold/40 bg-steel py-16 sm:py-20" aria-labelledby="system-title" data-id="element-251" data-mp="3bh233qpffq8m">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-252" data-mp="36jjzmfu6i380">
        <span className="inline-flex items-center gap-2 rounded-full bg-mineral px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-navy" data-id="element-253" data-mp="31lqyi17qfzel">
          <AwardIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-254" data-mp="2ws5vfura8f8j" /> The Most Comprehensive Surgical Instrumentation
          Teaching System in the World
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-255" data-mp="2nuvmwh5un47b">
          {productShortName}
        </h2>
        <p className="mt-3 font-semibold text-muted" data-id="element-256" data-mp="2duuzaj0y61xb">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach surgical instrumentation with confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-257" data-mp="18qzpnofa10i6">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-white/10 bg-navy/60 p-4 text-sm font-semibold text-muted" data-id="element-258" data-mp="u2v4mdsr4cw8">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-259" data-mp="1cr03p7ygr9op" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-gold bg-navy p-6 text-left text-lg font-bold leading-relaxed text-white shadow-lg shadow-black/30" data-id="element-260" data-mp="1bv1s665pf65">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-mineral" aria-hidden="true" data-id="element-261" data-mp="28xv0okdg9trg" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          surgical instrumentation works, why patient safety matters, and how surgical instrumentation contributes to
          safe, effective healthcare operations while maintaining ethical and professional responsibility.
        </p>
      </div>
    </section>;
}